import { render } from "./CreateDispute.vue?vue&type=template&id=39adc454&scoped=true"
import script from "./CreateDispute.vue?vue&type=script&lang=js"
export * from "./CreateDispute.vue?vue&type=script&lang=js"

import "./CreateDispute.vue?vue&type=style&index=0&id=39adc454&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39adc454"]])

export default __exports__